module.exports = __webpack_public_path__ + "img/Slice10-min.0cb7ac8d.png";